export default function Section({ children, id = null }) {
    return <div className="flex justify-center items-center h-screen mx-10 flex-wrap" id={id}>
        {children}
    </div>
}